import { QueryClient } from "react-query"

export const query = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false
    }
  }
})